import React from 'react';
import { MediumUp, MobileOnly } from 'src/ui/block';
import { ProductFilterComponents } from './product-filter-components';
import { FiltersWrapper } from './styles';

export const ProductFilters = () => {
  const renderProductFilterComponents = (isMobile: boolean) => {
    return (
      <FiltersWrapper>
        <ProductFilterComponents isMobile={isMobile} />
      </FiltersWrapper>
    );
  };

  return (
    <>
      <MediumUp>{renderProductFilterComponents(false)}</MediumUp>
      <MobileOnly>{renderProductFilterComponents(true)}</MobileOnly>
    </>
  );
};
